var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useField } from "@madmedical/form";
import { HStack, Radio, Text } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import FormControlWrapper from "../molecules/Form/FormControlWrapper";
const FormYesNoControl = (_a) => {
    var { name, isRequired, hint, label, labelProps, defaultValue } = _a, rest = __rest(_a, ["name", "isRequired", "hint", "label", "labelProps", "defaultValue"]);
    const { control, isError, error } = useField(name);
    const { t } = useTranslation();
    return (_jsx(Controller, { name: name, control: control, rules: { required: isRequired }, render: ({ field: { onChange, value } }) => {
            const handleChange = (value) => {
                onChange(value === "yes");
            };
            return (_jsx(FormControlWrapper, Object.assign({ isInvalid: isError, isRequired: isRequired, error: error, hint: hint, label: label, labelProps: labelProps }, { children: _jsx(Radio.Group, Object.assign({ name: name, value: value ? "yes" : "no", onChange: handleChange, isInvalid: isError, defaultValue: defaultValue ? "yes" : "no", accessibilityLabel: "" }, rest, { children: _jsxs(HStack, Object.assign({ space: 7 }, { children: [_jsx(Radio, Object.assign({ accessibilityLabel: t("yes"), value: "yes", borderWidth: 1 }, { children: _jsx(Text, { children: t("yes") }) }), "yes"), _jsx(Radio, Object.assign({ accessibilityLabel: t("no"), value: "no", borderWidth: 1 }, { children: _jsx(Text, { children: t("no") }) }), "no")] })) })) })));
        } }));
};
export default FormYesNoControl;
